<template>
  <Form ref="sysConfigForm" :model="sysConfig" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="sysConfig.id" type="hidden"/>

    <FormItem  :label="this.$t('common.sys-config.name.label')" prop="name">
      <Input v-model="sysConfig.name" :placeholder="$t('common.sys-config.name.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-config.sign.label')" prop="sign">
      <Input v-model="sysConfig.sign" :placeholder="$t('common.sys-config.sign.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-config.content.label')" prop="content">
      <Input v-model="sysConfig.content" :placeholder="$t('common.sys-config.content.holder')"  type="textarea" :rows="3"/>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-config.type.label')" prop="type">
      <Select v-model="sysConfig.type" :placeholder="$t('common.sys-config.type.holder')">
        <Option v-for="item in $t('common.sys-config.type.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('common.sys-config.remark.label')" prop="remark">
      <Input v-model="sysConfig.remark" :placeholder="$t('common.sys-config.remark.holder')"  type="textarea" :rows="3"/>
    </FormItem>

  </Form>
</template>
<script>
import api from '@/api'

export default {
  data () {
    return {
      sysConfig: {
        id: null,
        name: null,
        sign: null,
        content: null,
        type: 0,
        remark: null,
        createTime: null,
        updateTime: null,
        deleted: 0
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['sysConfigForm'].validate(valid => {
        if (valid) {
          if (this.sysConfig.id) {
            this.updateSysConfig(this.sysConfig).then(then).error(error)
          } else {
            this.createSysConfig(this.sysConfig).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.sysConfig.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['sysConfigForm'].resetFields());
    },
    getSysConfig(id,type){
      this.loading = true;
      this.$refs['sysConfigForm'].resetFields()
      api.common.SysConfig.detail(id).then(data => {
        this.sysConfig = data;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createSysConfig(sysConfig){
      this.loading = true;
      return api.common.SysConfig.add(sysConfig)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateSysConfig(sysConfig){
      this.loading = true;
      return api.common.SysConfig.update(sysConfig)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      name: [{type: 'string', required: true, message: this.$t('common.sys-config.name.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('common.sys-config.name.max'),trigger: 'blur'}],
      sign: [{type: 'string', required: true, message: this.$t('common.sys-config.sign.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('common.sys-config.sign.max'),trigger: 'blur'}],
      content: [{type: 'string', required: true, message: this.$t('common.sys-config.content.required'),trigger: 'blur'}, {type: 'string',max: 500, message: this.$t('common.sys-config.content.max'),trigger: 'blur'}],
      type: [{type: 'number', required: true, message: this.$t('common.sys-config.type.required'),trigger: 'blur'}],
      remark: [{type: 'string',max: 500, message: this.$t('common.sys-config.remark.max'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['sysConfigForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
